import React, { useState } from "react";

function ProjectDiv(props) {
  const [ isHovered, setIsHovered ] = useState(false);

  function toggleClick() {
    setIsHovered(prevValue => !prevValue);
  }
  
  return (
    <>
    {isHovered === false ?
      <div className="project-divs" onClick={toggleClick}>
        <h2 className="project-div-headers">{props.heading.replace("_"," ")}</h2>
        <p className="project-blurb">{props.description}</p>
        <img src={require(`../../media/${props.imageName}.png`).default} alt={props.heading} className="project-screenshots"/>
      </div>
      :
      <div className="project-divs" onClick={toggleClick}>
        <div className="project-links">
          <a href={props.demoUrl} rel="noopener noreferrer" target="_blank">
            <button className="buttons small-buttons">Demo</button>
          </a>
          <a href={props.gitUrl} rel="noopener noreferrer" target="_blank">
            <button className="buttons small-buttons" disabled={!props.gitUrl}>{props.gitUrl ? "GitHub" : "Private"}</button>
          </a>
        </div>
      </div>
    }
    </>
  );
}

export default ProjectDiv;